import { Component, type ErrorInfo, type ReactNode } from 'react';
import { trackError } from '@/lib/error-tracking';

interface ErrorBoundaryProps {
  children: ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

export const ErrorFallback = () => {
  return (
    <div data-linear className="ln-app">
      <div className="ln-main">
        <div className="ln-page">
          <div className="ln-empty">
            <div className="ln-empty-title">Something went wrong</div>
            <div>An unexpected error occurred. Try reloading the page.</div>
            <button
              type="button"
              className="ln-toolbar-btn"
              onClick={() => window.location.reload()}
            >
              Reload
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  state: ErrorBoundaryState = { hasError: false };

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, _info: ErrorInfo): void {
    trackError('React render error', error);
  }

  render(): ReactNode {
    if (this.state.hasError) {
      return <ErrorFallback />;
    } else {
      return this.props.children;
    }
  }
}
